import React from "react"

import WPImage, { DISPLAY_MODE } from "../_base/WPImage"
import WPCta from "../_base/WPCta"

import * as registerNowStyles from "../../styles/world_championships/RegisterNow.module.css"

const RegisterNow = props => {
  const { content } = props

  return (
    <div id="register-now" className="container-fluid">
      <div className={`row ${registerNowStyles.wrapper}`}>
        <div className="col">
          <div style={{ display: "grid", gridAutoRows: "1fr" }}>
            <div
              style={{
                gridArea: "1/1",
                position: "relative",
                placeItems: "left",
                display: "grid",
                zIndex: 2,
              }}
            >
              <div className={`row g-0`}>
                <div className={`col-12 ${registerNowStyles.content}`}>
                  <div className={`row g-0`}>
                    <div className={`col-12 ${registerNowStyles.logoWrapper}`}>
                      <h1>Upcoming Events 2025</h1>
                      {/* <WPImage
                        holder={content}
                        selector={`c-logo`}
                        mode={DISPLAY_MODE.normal}
                        className={`${registerNowStyles.logo}`}
                      /> */}
                    </div>
                  </div>
                  <div className={`row g-0`}>
                    <div className={`col-12 ${registerNowStyles.tableWrapper}`}>
                      <table className={`table ${registerNowStyles.table}`}>
                        <thead>
                          <tr>
                            <th scope="col">Event</th>
                            <th scope="col">City</th>
                            <th scope="col">Date</th>
                            <th scope="col">Register</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className={`${registerNowStyles.colored}`}>
                            <th scope="row">
                              TM1 World Championship Qualifier Event
                            </th>
                            <td>London</td>
                            <td>Apr 24</td>
                            <td>
                              <a href="mailto:tm1worldchampionship@cubewise.com">
                                Register
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">
                              TM1 World Championship Qualifier Event
                            </th>
                            <td>Sydney</td>
                            <td>May 14</td>
                            <td>
                              <a href="mailto:tm1worldchampionship@cubewise.com">
                                Register
                              </a>
                            </td>
                          </tr>
                          <tr className={`${registerNowStyles.colored}`}>
                            <th scope="row">
                              TM1 World Championship Qualifier Event
                            </th>
                            <td>Melbourne</td>
                            <td>May 20</td>
                            <td>
                              <a href="mailto:tm1worldchampionship@cubewise.com">
                                Register
                              </a>
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">Online Qualifier Registration</th>
                            <td>Online</td>
                            <td>Jun 27</td>
                            <td>
                              <a href="">Register</a>
                            </td>
                          </tr>
                          <tr className={`${registerNowStyles.colored}`}>
                            <th scope="row">APAC Semi Finals Event </th>
                            <td>Online</td>
                            <td>TBC</td>
                            <td>
                              <a href="">Register</a>
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">European Semi Finals Event</th>
                            <td>Online</td>
                            <td>TBC</td>
                            <td>
                              <a href="">Register</a>
                            </td>
                          </tr>
                          <tr className={`${registerNowStyles.colored}`}>
                            <th scope="row">TechXchange Orlando</th>
                            <td>Orlando</td>
                            <td>TBC</td>
                            <td>
                              <a href="">Register</a>
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">TM1 World Championship Finals</th>
                            <td></td>
                            <td>TBC</td>
                            <td>
                              <a
                                href="mailto:tm1worldchampionship@cubewise.com?subject=Register for online event"
                                target="_top"
                              >
                                Register
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`${registerNowStyles.backgroundContainmentImage}`}
              style={{
                gridArea: "1/1",
                objectFit: "cover",
                placeItems: "right",
                zIndex: 1,
              }}
              objectfit="cover"
              placeholderstyle={{
                objectFit: `cover`,
                objectPosition: `right bottom`,
              }}
              imgstyle={{
                objectFit: `cover`,
                objectPosition: `right bottom`,
              }}
              transformoptions={{ fit: "cover" }}
            >
              <WPImage
                holder={content}
                selector={`media-asset`}
                mode={DISPLAY_MODE.normal}
                className={`d-none d-lg-flex ${registerNowStyles.backgroundImage}`}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RegisterNow
